// Chakra imports
import {
  Badge,
  Box,
  Flex,
  IconButton,
  SimpleGrid,
} from '@chakra-ui/react';

import TableComponent from 'components/TableComponent';
import { queryClient } from 'index';
import { DateTime } from 'luxon';
import { FC, useMemo } from 'react';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { Column } from 'react-table';
import {
  ChargeBatch,
  ChargeBatchItemStatus,
  ChargeBatchStatus,
  findChargeBatches,
} from 'services/api.service';

export const ChargeBatchStatusRender: FC<{ status: ChargeBatchStatus }> = ({ status }) => {
  if (status === 'PENDING') return <Badge colorScheme="orange">Pendente</Badge>;
  if (status === 'PROCESSING') return <Badge colorScheme="blue">Processando</Badge>;
  if (status === 'COMPLETED') return <Badge colorScheme="green">Concluído</Badge>;
  if (status === 'PARTIALLY_COMPLETED') return <Badge colorScheme="yellow">Parcial</Badge>;
  if (status === 'FAILED') return <Badge colorScheme="red">Falhou</Badge>;
  return null;
};

export const ChargeBatchItemStatusRender: FC<{ status: ChargeBatchItemStatus }> = ({ status }) => {
  if (status === 'PENDING') return <Badge colorScheme="orange">Pendente</Badge>;
  if (status === 'PROCESSING') return <Badge colorScheme="blue">Processando</Badge>;
  if (status === 'SUCCEEDED') return <Badge colorScheme="green">Sucesso</Badge>;
  if (status === 'FAILED') return <Badge colorScheme="red">Falhou</Badge>;
  if (status === 'SKIPPED_DUPLICATE') return <Badge colorScheme="gray">Duplicado</Badge>;
  return null;
};

export default function ChargesBatch() {
  const navigate = useNavigate();

  const columns = useMemo(
    () =>
      [
        {
          accessor: 'createdAt',
          Header: 'Criado em',
          Cell: ({ value }: { value: string }) => {
            return DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm:ss');
          },
        },
        {
          Header: 'Status',
          accessor: 'status',
          Cell: ({ value }: { value: ChargeBatchStatus }) => {
            return <ChargeBatchStatusRender status={value} />;
          },
        },
        {
          Header: 'Itens',
          accessor: 'totalItems',
        },
        {
          Header: 'Sucesso',
          accessor: 'succeededItems',
        },
        {
          Header: 'Falhas',
          accessor: 'failedItems',
        },
        {
          Header: 'Ações',
          accessor: 'actions',
        },
      ] as Column[],
    [],
  );

  const actions = (row: ChargeBatch) => (
    <Flex align="center" justify="flex-start" w="100%">
      <IconButton
        aria-label="Ver itens"
        size="sm"
        variant="outline"
        icon={<FaEye />}
        onClick={() => navigate(`/access/charges-batch/${row.id}`)}
      />
    </Flex>
  );

  const handleRefresh = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['findChargeBatches'],
    });
  };

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      <Box>
        <SimpleGrid
          mb="20px"
          columns={{ sm: 1 }}
          spacing={{ base: '20px', xl: '20px' }}
        >
          <TableComponent
            label="Cobranças em Lote"
            columnsData={columns}
            queryFn={findChargeBatches}
            queryKey="findChargeBatches"
            actions={actions}
          />
        </SimpleGrid>
      </Box>
    </PullToRefresh>
  );
}
